'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dOystr$002dAdmin$002dPage$0024 from "./presto.-Oystr-Admin-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002489 from "./presto.-Presto-Router$$anon$89.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$88() {
  this.bpH = null;
  this.bpz = null;
  this.bpA = false;
  this.bpI = null;
  this.bpJ = false;
  this.bpM = null;
  this.bpF = null;
  this.bpG = false;
  this.bpB = null;
  this.bpC = false;
  this.bpD = null;
  this.bpE = false;
  this.bpK = false;
  this.bpL = false;
  this.bpH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bpM = "OystrAdminPage";
}
export { $c_Lpresto_PrestoRouter$$anon$88 as $c_Lpresto_PrestoRouter$$anon$88 };
$p = $c_Lpresto_PrestoRouter$$anon$88.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$88;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$88() {
}
export { $h_Lpresto_PrestoRouter$$anon$88 as $h_Lpresto_PrestoRouter$$anon$88 };
$h_Lpresto_PrestoRouter$$anon$88.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bpH;
});
$p.M = (function() {
  if ((!this.bpA)) {
    this.bpz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bpA = true;
  }
  return this.bpz;
});
$p.O = (function() {
  if ((!this.bpJ)) {
    this.bpI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bpJ = true;
  }
  return this.bpI;
});
$p.D = (function() {
  return this.bpM;
});
$p.t = (function() {
  if ((!this.bpG)) {
    this.bpF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpG = true;
  }
  return this.bpF;
});
$p.N = (function() {
  if ((!this.bpC)) {
    this.bpB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpC = true;
  }
  return this.bpB;
});
$p.Q = (function() {
  if ((!this.bpE)) {
    this.bpD = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002489.$c_Lpresto_PrestoRouter$$anon$89();
    this.bpE = true;
  }
  return this.bpD;
});
$p.v = (function() {
  if ((!this.bpL)) {
    this.bpK = false;
    this.bpL = true;
  }
  return this.bpK;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee563) => ((p) => \u03b4scrutinee563))($j_presto$002e$002dOystr$002dAdmin$002dPage$0024.$m_Lpresto_OystrAdminPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$88, "presto.PrestoRouter$$anon$88", ({
  P5: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$88 as $d_Lpresto_PrestoRouter$$anon$88 };
//# sourceMappingURL=presto.-Presto-Router$$anon$88.js.map
